import React from "react"
import PropTypes from "prop-types"

// Post Header
export const PostHeader = ({
  title,
  titleClassName,
  category,
  date,
  img,
  imgAlt,
  className,
  children,
}) => {
  // const renderAttr = () => {
  //   if (category && date) {
  //     return (
  //       <>
  //         <span className="post-category">{category}</span>
  //         <span className="post-attr-divider">•</span>
  //         <span className="post-date">{date}</span>
  //       </>
  //     )
  //   } else if (category) {
  //     return <span className="post-category">{category}</span>
  //   } else if (date) {
  //     return <span className="post-date">{date}</span>
  //   } else {
  //     return null
  //   }
  // }
  return (
    <div className="pb-3">
      <div className={`post-header ${className}`}>
        <span
          className="post-category pb-3"
          dangerouslySetInnerHTML={{ __html: category }}
        ></span>
        {title && (
          <h1
            className={`h1 ${titleClassName}`}
            dangerouslySetInnerHTML={{ __html: title }}
          ></h1>
        )}
        <span className="post-date">{date}</span>
        {/* {(category || date) && <div className="post-attr">{renderAttr()}</div>} */}
        {img && <img className="post-cover" src={img} alt={imgAlt || title} />}
        {children}
      </div>
    </div>
  )
}

PostHeader.propTypes = {
  title: PropTypes.string,
  titleClassName: PropTypes.string,
  category: PropTypes.string,
  date: PropTypes.string,
  img: PropTypes.any,
  imgAlt: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any,
}

PostHeader.defaultProps = {
  titleClassName: "",
  className: "",
}

// Post Content
export const PostContent = ({ className, children }) => {
  return (
    <>
      <div className={`post-content ${className}`}>{children}</div>
    </>
  )
}

PostContent.propTypes = {
  className: PropTypes.string, // Set optional classes
  children: PropTypes.any,
}

PostContent.defaultProps = {
  className: "",
}
